import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addItem: {
    id: 'items-form.add-item',
    defaultMessage: 'Add item',
  },
  editItem: {
    id: 'items-form.edit-item',
    defaultMessage: 'Edit {itemName}',
  },
  itemNameLabel: {
    id: 'items-form.label.item-name',
    defaultMessage: 'Item name',
  },
  itemNamePlaceholder: {
    id: 'items-form.placeholder.item-name',
    defaultMessage: 'E.g. “Berry Smoothie”',
  },
  itemDescriptionLabel: {
    id: 'items-form.label.item-description',
    defaultMessage: 'Item description',
  },
  itemDescriptionPlaceholder: {
    id: 'items-form.placeholder.item-description',
    defaultMessage: 'E.g. “Seasonal berry smoothie. Contains soy and tree nuts.”',
  },
  duplicateItemNamePlaceholder: {
    id: 'items-form.placeholder.duplicate-item-name',
    defaultMessage: 'Copy of {duplicateItemName}',
  },
  selectCategory: {
    id: 'items-form.select-category',
    defaultMessage: 'Select category',
  },
  otherCategory: {
    id: 'items-form.other-category',
    defaultMessage: 'Other',
  },
  menuPriceLabel: {
    id: 'items-form.label.menu-price',
    defaultMessage: 'Menu price',
  },
  taxExcludedMenuPriceDescription: {
    id: 'items-form.description.menu-price-tax-excluded',
    defaultMessage: 'The price on your menu, not including tax. We’ll use this to calculate your payout.',
  },
  taxIncludedMenuPriceDescription: {
    id: 'items-form.description.menu-price-tax-included',
    defaultMessage: 'The price on your menu, including tax. We’ll use this to calculate your payout.',
  },
  editPriceBanner: {
    id: 'items-form.banner.edit-price',
    defaultMessage:
      'If your menu price changes, our team will need to verify the new price before it becomes available to order.',
  },
  payoutLabel: {
    id: 'items-form.label.payout',
    defaultMessage: 'Payout',
  },
  payoutTooltip: {
    id: 'items.items-form.payout-tooltip',
    defaultMessage:
      'Your payout is calculated based on your listed menu price for this item. For item tax clarifications, please see <a>here</a>.',
  },
  linkToMenuLabel: {
    id: 'items-form.label.link-to-menu',
    defaultMessage: 'Link to menu',
  },
  linkToMenuPlaceholder: {
    id: 'items-form.placeholder.link-to-menu',
    defaultMessage: 'https://www.example.com/menu',
  },
  linkToMenuDescription: {
    id: 'items-form.description.link-to-menu',
    defaultMessage: 'Required for price verification.',
  },
  priceVerification: {
    id: 'items-form.price-verification',
    defaultMessage: 'We must verify the price of this item before it becomes available to order.',
  },
  itemAvailabilityLabel: {
    id: 'items-form.label.item-availability',
    defaultMessage: 'Item availability',
  },
  optionalLabel: {
    id: 'items-form.label.optional',
    defaultMessage: 'Optional',
  },
  itemAvailabilityDescription: {
    id: 'items-form.description.item-availability',
    defaultMessage: 'This controls when ClassPass users can order this item.',
  },
  subsequentItemAvailabilityDescription: {
    id: 'items-form.description.subsequent-item-availability',
    defaultMessage:
      'This controls when ClassPass users can order this item.<br></br>The most common configuration is used as a default.',
  },
  availabilityTimeWindow: {
    id: 'items-form.availability-time-window',
    defaultMessage: '{startTime} - {endTime}',
  },
  availabilityUnavailable: {
    id: 'items-form.availability-unavailable',
    defaultMessage: 'Unavailable',
  },
  contactButton: {
    id: 'items-form.button.contact',
    defaultMessage: 'Contact support',
  },
  cancelButton: {
    id: 'items-form.button.cancel',
    defaultMessage: 'Cancel',
  },
  submitButton: {
    id: 'items-form.button.submit',
    defaultMessage: 'Submit for review',
  },
  addItemAvailabilityButton: {
    id: 'items-form.button.add-item-availability',
    defaultMessage: 'Add item availability',
  },
  editButton: {
    id: 'items-form.button.edit',
    defaultMessage: 'Edit',
  },
  saveButton: {
    id: 'items-form.button.save',
    defaultMessage: 'Save',
  },
  deleteButton: {
    id: 'items-form.button.delete',
    defaultMessage: 'Delete item',
  },
  itemNameMustBeUnique: {
    id: 'items-form.errors.item-name-must-be-unique',
    defaultMessage: 'Item name must be unique.',
  },
  invalidUrl: {
    id: 'items-form.errors.invalid-url',
    defaultMessage: 'A valid menu link is required.',
  },
  saveError: {
    id: 'items-form.errors.save-error',
    defaultMessage:
      'Oops! We were unable to save your item. Please make sure you filled out all required fields correctly.',
  },
  submitError: {
    id: 'items-form.errors.submit-error',
    defaultMessage:
      'Oops! We were unable to submit your item. Please make sure you filled out all required fields correctly.',
  },
  errorAddItem: {
    id: 'items-form.errors.add-item',
    defaultMessage: '<strong>We were unable to add your item</strong>',
  },
  successEditItem: {
    id: 'items-form.success.edit-item',
    defaultMessage: '<strong>{itemName}</strong> was successfully updated',
  },
  errorEditItem: {
    id: 'items-form.errors.edit-item',
    defaultMessage: '<strong>We were unable to update your item</strong>',
  },
});
